// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2aS4R","title":"ClientInsurance_title__2sED4","itemText":"ClientInsurance_itemText__3Q_-M"};